import { querySelectArray } from './utils';

const InitFeedbackForm = () => {
    if (!document.querySelector('.article-select-dropdown')) return;

    const translationElement = document.querySelector('[data-form-translations]');
    const t = translationElement
        ? JSON.parse(translationElement.getAttribute('data-form-translations'))
        : {
            topicsPlaceholder: 'Select',
            articlesPlaceholder: 'Select topic first',
        };

    init();

    function init() {
        unhideArticleSelector();
        clearArticleOptions(
            document.querySelector('select.article-select-dropdown'),
        );
        addListenerToPopulateArticleSelect();
        document.addEventListener('pjax:complete', InitFeedbackForm);
    }

    function unhideArticleSelector() {
        querySelectArray('.article-select-dropdown', document).forEach(el => {
            el.classList.remove('u-hide');
        });
    }

    function clearArticleOptions(articleSelect) {
        articleSelect.innerHTML = ''; // remove all options
        const defaultSelection = document.createElement('option');
        const isTopicSelected =
            document.querySelector('select[name="TopicPageID"]').value !== '';
        defaultSelection.text = isTopicSelected
            ? t.topicsPlaceholder
            : t.articlesPlaceholder;
        defaultSelection.setAttribute('value', '');
        articleSelect.appendChild(defaultSelection);
    }

    function populateArticleOptions(articleSelect, nextArticleSelectData) {
        Object.keys(nextArticleSelectData).forEach(key => {
            const newOption = document.createElement('option');
            newOption.setAttribute('value', key);
            newOption.innerHTML = nextArticleSelectData[key];
            articleSelect.appendChild(newOption);
        });
    }

    function updateArticleOptions(articleSelect, nextArticleSelectData) {
        clearArticleOptions(articleSelect);
        populateArticleOptions(articleSelect, nextArticleSelectData);
    }

    function handleSelectChange(e, articleSelectData) {
        const selectedTopicId = e.target.value;
        const articleSelect = document.querySelector(
            'select.article-select-dropdown',
        );

        if (selectedTopicId > 0) {
            articleSelect.disabled = false;
            const nextArticleSelectData = articleSelectData[selectedTopicId];
            updateArticleOptions(articleSelect, nextArticleSelectData);
        } else {
            articleSelect.disabled = true;
            clearArticleOptions(articleSelect);
        }
    }

    function addListenerToPopulateArticleSelect() {
        const articleSelectData = JSON.parse(
            document
                .querySelector('select.article-select-dropdown')
                .getAttribute('data-articles'),
        );
        document
            .querySelector('#Form_ContactForm_TopicPageID')
            .addEventListener('change', event =>
                handleSelectChange(event, articleSelectData),
            );
    }
};

export default InitFeedbackForm;
